module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    class: _vm.classStyle,
    style: (_vm.style),
    attrs: {
      "show": _vm.show,
      "options": _vm.options,
      "reference": _vm.reference
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-056605bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/vue-progressbar.vue
// module id = 66
// module chunks = 2